import React from "react";

export default function PhotoCategories({ categories, onSelectCategory }) {
  // Kategorilerden sadece ilk 4 tanesini alır
  const limitedCategories = categories.slice(0, 3);

  return (
    <div className="photo-quick-section">
      <div className="photo-menu-head">
        <span className="eyebrow">UNSERE HIGHLIGHTS</span>
        <h2 className="heading">Kategorien</h2>
        <p>Wählen Sie eine Kategorie, um die Leckereien zu sehen</p>
      </div>
      <div className="photo-quick-row">
        {limitedCategories.map((cat) => (
          <button
            key={cat.id}
            className="photo-quick"
            onClick={() => onSelectCategory(cat)}
          >
            <span>
              <img src={cat.image} alt={cat.title} />
            </span>
            <b>{cat.title}</b>
          </button>
        ))}
      </div>
    </div>
  );
}
